import Image from '@atlaskit/image';

import { Box } from '@atlaskit/primitives/box';

import { xcss } from '@atlaskit/primitives/xcss/xcss';

import Skeleton from '@atlaskit/skeleton';

import { token } from '@atlaskit/tokens';

import { getGlobalTheme } from '@atlaskit/tokens/get-global-theme';

import { type HTMLAttributes, useState } from 'react';

import { type JSX } from 'react/jsx-runtime';

const imageContainerStyles = xcss({
	borderTopRightRadius: token('radius.small'),
	borderBottomRightRadius: token('radius.small'),
	position: 'relative',
	overflow: 'hidden',
});

export const SkeletonImage = ({
	src,
	srcDark,
	alt,
	testId,
	imageStyles = {},
}: {
	src: string;
	srcDark: string;
	alt: string;
	testId: string;
	imageStyles?: HTMLAttributes<HTMLImageElement>['style'];
}): JSX.Element => {
	const [imageLoaded, setImageLoaded] = useState(false);
	const isDarkMode = getGlobalTheme().colorMode === 'dark';

	return (
		<Box xcss={imageContainerStyles}>
			{!imageLoaded && <Skeleton width="100%" height="100%" borderRadius={token('radius.small')} />}
			<Image
				src={isDarkMode ? srcDark : src}
				style={{
					...imageStyles,
					opacity: imageLoaded ? 1 : 0,
					transition: 'opacity 0.2s ease-in-out',
				}}
				alt={alt}
				testId={testId}
				onLoad={() => setImageLoaded(true)}
				onError={() => setImageLoaded(true)}
			/>
		</Box>
	);
};
